import { Component } from '@angular/core';
import { LoaderComponent } from './loader/loader.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, LoaderComponent]
})
export class AppComponent {
  title = 'client-signup';
}
